<template>
  <div>
    <div class="mt-3 titlePage">Liberar Vagas Reservadas</div>

    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsTecnico"
          :orderby="sortBy"
          :items="lstVagas"
          :optionsButton="optionsButton"
          responsive
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :mostrarQuantidade="false"
          :titlePDF="titlePage"
        ></fccTable>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '../../../store'
export default {
  data() {
    return {
      titlePage: 'Publicações',
      sortBy: 'nome',
      itemPorPage: '5',
      lstVagas: [],
      optionsButton: [
        {
          funcaoButton: 'FinalizarVagas',
          tooltip: 'Liberar',
          icon: 'check',
          text: 'Liberar',
          variant: 'primary',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fieldsTecnico: [
        {
          key: 'nmfuncionario',
          label: 'Técnico',
          sortable: true
        },
        { key: 'dtliberacao', label: 'Data', sortable: true }
      ]
    }
  },
  methods: {
    FinalizarVagas() {
      this.callConfirm('Deseja liberar as vagas reservadas? ', '').then((result) => {
        if (result.value) {
          axios
            .get(
              this.baseUrlPublicacao +
                'Publicacao/LiberarVagasReservadas/' +
                this.controlePage.spi +
                '/' +
                this.dadosUserSession.usuCdFuncionario,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then((resposta) => {
              if (resposta.data.inconsistencia != null) {
                this.callAlert(
                  'Erro na exportação',
                  resposta.data.inconsistencia[0].obs,
                  'error',
                  'error'
                )
                this.callNotifications(
                  'Erro na exportação',
                  'Ordem: ' +
                    resposta.data.inconsistencia[0].ordem +
                    ' - ' +
                    'Posto: ' +
                    resposta.data.inconsistencia[0].posto,
                  'danger'
                )
              } else {
                this.callToast('Sucesso ao exportar')
                this.listarVagas()
              }
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    listarVagas() {
      axios
        .get(
          this.baseUrlPublicacao +
            'Publicacao/UsuarioVagasReservadasLiberadas/' +
            this.controlePage.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstVagas = response.data.retorno
        })
        .catch(this.setErrorSystem)
    }
  },
  props: {
    controlePage: Object,
    baseUrlPublicacao: String
  },
  mounted() {
    this.listarVagas()
  }
}
</script>
